<script setup>
import SlideoutWithSlots from './slideoutWithSlots.vue';

defineProps({
    title: {
        type: String,
        default: null,
    },
    allowSelfClose: {
        type: Boolean,
        default: true,
    },
    maxWidthClass: {
        type: String,
        default: 'max-w-lg',
    },
    resizeable: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['close', 'self-close-prevented']);
</script>

<template>
    <slideout-with-slots
        :title="title"
        :allow-self-close="allowSelfClose"
        :max-width-class="maxWidthClass"
        :resizeable="resizeable"
        @close="$emit('close')"
        @self-close-prevented="$emit('self-close-prevented')"
    >
        <template v-if="$slots.title" #title>
            <slot name="title"></slot>
        </template>

        <template v-if="$slots.actions" #actions>
            <slot name="actions"></slot>
        </template>

        <template #body>
            <slot name="body"></slot>
        </template>
    </slideout-with-slots>
</template>
